<template>
  <canvas id="line-chart-channel-intent" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
export default {
  name: "LineChartChannelIntent",
  props: {
    data: {
      type: Object,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "count",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: "จำนวนคนใช้งาน",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: this.yAxisTitle,
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#575757",
            backgroundColor: "#F1F1F1",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: function(context) {
                const contextElement = context[0];
                const chartDatas = contextElement.chart.data.datasets;
                const labelCollect = chartDatas.map((chartData) => {
                  const label = chartData.label;
                  const index = contextElement.dataIndex;
                  const data = chartData.data[index];
                  const dataFormated = data.countFormat
                  const unit = "คน";
                  return `${label} ${dataFormated} ${unit}`;
                });
                return labelCollect.join("\n");
              },
              label: function(context) {
                return;
              },
              afterLabel: function(context) {
                return;
              },
            },
          },
        },
      },
      gradient: null,
    };
  },
  mounted() {
    const ctx = document
      .getElementById("line-chart-channel-intent")
      .getContext("2d");
    const gradientColor1 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor1.addColorStop(0, "rgba(113, 96,196, 0.5)");
    gradientColor1.addColorStop(0.5, "rgba(113, 96, 196, 0.25)");
    gradientColor1.addColorStop(1, "rgba(113, 96, 196, 0)");

    const gradientColor2 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor2.addColorStop(0, "rgba(92, 183, 217, 0.5)");
    gradientColor2.addColorStop(0.5, "rgba(92, 183, 217, 0.25)");
    gradientColor2.addColorStop(1, "rgba(92, 183, 217, 0)");

    const gradientColor3 = ctx.createLinearGradient(0, 0, 0, 350);
    gradientColor3.addColorStop(0, "rgba(233, 210, 244, 0.5)");
    gradientColor3.addColorStop(0.5, "rgba(233, 210, 244, 0.25)");
    gradientColor3.addColorStop(1, "rgba(233, 210, 244, 0)");

    new Chart(ctx, {
      type: "bar",
      data: {
        datasets: [
          {
            type: "line",
            label: "line",
            order: 1,
            backgroundColor: gradientColor1,
            borderColor: "#e9d2f4",
            pointBackgroundColor: "#e9d2f4 ",
            pointBorderColor: "#e9d2f4 ",
            data: this.data.lineChannel,
            tension: 0.4,
            fill: true,
          },
          {
            type: "line",
            label: "mobile",
            order: 2,
            backgroundColor: gradientColor2,
            borderColor: "#5CB7D9",
            pointBackgroundColor: "#5CB7D9",
            pointBorderColor: "#5CB7D9",
            data: this.data.mobileChannel,
            tension: 0.4,
            fill: true,
          },
          {
            type: "line",
            label: "web",
            order: 3,
            backgroundColor: gradientColor3,
            borderColor: "#7160C4",
            pointBackgroundColor: "#7160C4",
            pointBorderColor: "#7160C4",
            data: this.data.webChannel,
            tension: 0.4,
            fill: true,
          },
        ],
      },
      options: this.options,
    });
  },
};
</script>

<style lang="scss" scoped></style>
